import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';


class CreateBoat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boatName: ''
        }

    }
    render() {
        return (
            <div id="createBoat" class="logForm">
                <Formik
                    initialValues={{ boatName: '' }}
                    validationSchema={Yup.object({
                        boatName: Yup.string()
                            .max(25, 'Nom du navire trop long')
                            .required('Veuillez nommer votre navire')
                    })}
                    onSubmit={(values) => {
                        this.props.createBoat(values);
                    }}>
                    <Form>
                        <h2>Nouveau navire</h2>

                        <div class="content">
                            <span class="formLabels">
                                <label htmlFor="boatName">Nom du navire</label>
                            </span>
                            <span class="formInputs">
                                <Field name="boatName" type="text" placeholder="Santa Maria"></Field>
                            </span>
                        </div>
                        <div class="formError">
                            <p><ErrorMessage name="boatName" /></p>
                        </div>
                        <input type="submit" value="Embarquer" />
                    </Form>
                </Formik>
            </div>
        );
    }
}


export default CreateBoat;
